export default __webpack_public_path__ + "static/media/281.26b11368.png";